/* Lumine - colour-aware product gallery.
   The product section renders every image in one gallery. This filters it
   to the selected colour, using the data-colour attribute that the section
   derives from each image's alt text.

   Fails open: if no image carries a colour label (e.g. single-colour
   products whose alt text has not been written yet), nothing is hidden. */
(function () {
  var gallery = document.getElementById('prodGallery');
  if (!gallery) return;

  var slides = [].slice.call(gallery.querySelectorAll('.gal-img'));
  if (!slides.length) return;

  var dotsWrap = document.getElementById('mobDots');

  function norm(s) {
    return (s || '').trim().toLowerCase();
  }

  function matching(colour) {
    var c = norm(colour);
    if (!c) return slides;
    var hits = slides.filter(function (s) {
      return norm(s.getAttribute('data-colour')) === c;
    });
    /* fail open */
    return hits.length ? hits : slides;
  }

  function buildDots(visible) {
    if (!dotsWrap) return;
    if (visible.length < 2) {
      dotsWrap.innerHTML = '';
      dotsWrap.style.display = 'none';
      return;
    }
    dotsWrap.style.display = '';
    dotsWrap.innerHTML = '';
    visible.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mob-dot' + (i === 0 ? ' active' : '');
      b.setAttribute('data-index', String(i));
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', function () {
        gallery.scrollTo({ left: i * gallery.clientWidth, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
    });
  }

  function syncDots() {
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.mob-dot');
    if (!dots.length) return;
    var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('active', i === idx);
    }
  }

  function apply(colour) {
    var visible = matching(colour);
    slides.forEach(function (s) {
      s.style.display = visible.indexOf(s) === -1 ? 'none' : '';
    });
    buildDots(visible);
    gallery.scrollTo({ left: 0, behavior: 'auto' });
    if (window.innerWidth > 1024) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  gallery.addEventListener('scroll', syncDots, { passive: true });

  var swatches = [].slice.call(document.querySelectorAll('.col-sq'));
  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      apply(this.getAttribute('data-col'));
    });
  });

  var start = document.querySelector('.col-sq.sel') || swatches[0];
  apply(start ? start.getAttribute('data-col') : '');
})();
